module.exports = __webpack_public_path__ + "img/index12.c8974617.png";